import Item from '../../canvas-timeline/canvas_timeline_item';
import {ITEM_TYPE, drawRectangle} from '../../canvas-timeline/canvas_timeline_util';
import Util from '../../../../forecast-app/shared/util/util';
class TimeOffItem extends Item {
	constructor(data) {
		super(ITEM_TYPE.PEOPLE_SCHEDULING_HEATMAP, data);
	}

	draw(canvasContext) {
		const {data} = this;
		const {x, y, width, groupHeight, isToday, intl} = data;
		const backgroundColor = '#f2f2f2';
		const backgroundOpacity = isToday ? 0 : 1;
		drawRectangle(canvasContext, x, y, width - 1, groupHeight, {
			backgroundColor,
			backgroundOpacity,
		});

		canvasContext.font = '600 10px ' + Util.getFontFamily();
		canvasContext.fillStyle = '#a7a7a7';
		let text = intl.formatMessage({id: 'common.time_off'});
		let textWidth = canvasContext.measureText(text).width;
		canvasContext.fillText(text, x + (width - textWidth) / 2, y + 29);
	}
}
export default TimeOffItem;
